export const VERIFICATION_UPLOAD_DOCUMENT_API =
	'/subscriber/verification/document/upload';

export const VERIFICATION_USER_DETAILS_API = '/subscriber/details';

export const VERIFICATION_QUERY_KEY = 'user_verification_state';
export const VERIFICATION_QUERY_EOG = 'user_verification_eog';
